import { render } from "./MenusEdit.vue?vue&type=template&id=6054bab4&scoped=true"
import script from "./MenusEdit.vue?vue&type=script&lang=js"
export * from "./MenusEdit.vue?vue&type=script&lang=js"

import "./MenusEdit.vue?vue&type=style&index=0&id=6054bab4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6054bab4"]])

export default __exports__